import React, { useState } from "react";
import { Form, Row, Col } from "react-bootstrap";


function AddressForm () {

    const [form, setForm] = useState({});


return (
    <>
        { /* Address: street, town, postcode, country */}

        <Form.Group className="mb-3" as={Row}>
           <Form.Label column sm={2}>Street</Form.Label>
           <Col sm={10}>
           <Form.Control
               value={form.street}
               onChange={(e) => setForm({ ...form, 
                street: e.target.value })}
               required
               type="text"
           />
           </Col>
           <Form.Control.Feedback type="invalid">
               This field is required.
           </Form.Control.Feedback>
       </Form.Group>

    <Row className="ml-5">
        <Col>
        <Form.Group as={Row}>
           <Form.Label  column sm={4}>Town</Form.Label>
           <Col sm={6}>
           <Form.Control
               value={form.town}
               onChange={(e) => setForm({ ...form, 
                town: e.target.value })}
               required
               type="text"
           />
           </Col>
           <Form.Control.Feedback type="invalid">
               This field is required.
           </Form.Control.Feedback>
       </Form.Group>
       </Col>
       <Col>
        <Form.Group className="mb-3" as={Row}>
            <Form.Label column sm={4}>Postal code</Form.Label>
            <Col sm={6}>
            <Form.Control
                value={form.postcode}
                onChange={(e) => setForm({ ...form, 
                    postcode: e.target.value })}
                required
                type="text"
            />
            </Col>
            <Form.Control.Feedback type="invalid">
                This field is required.
            </Form.Control.Feedback>
        </Form.Group>
        </Col>
    </Row>
        <Form.Group className="mb-3" as={Row}>
            <Form.Label column sm={2}>Country</Form.Label>
            <Col sm={3}>
            <Form.Control
                value={form.country}
                onChange={(e) => setForm({ ...form, 
                    country: e.target.value })}
                required
                type="text"
            />
            </Col>
            <Form.Control.Feedback type="invalid">
                This field is required.
            </Form.Control.Feedback>
        </Form.Group>


         <Form.Group className="mb-3" as={Row}>
            <Form.Label column sm={2}>Country2</Form.Label>
            <Col sm={3}>
            <Form.Select>
                <option>Country</option>
                <option value="TR">Türkiye</option>
                <option value="FR">France</option>
                <option value="NL">Netherlands</option>
            </Form.Select>
            </Col>   
        </Form.Group>
    </>
);

}


export default AddressForm;